<template>
	<div class="paineis-personalizados">
		<az-toolbar
		><template #actions><strong class="primary--text">Painéis Personalizados</strong></template>
		</az-toolbar>
		<az-container>
			<hal-dashboard style="height: 100%" formato-lista="Lista" :produto-id="idProduto"></hal-dashboard>
		</az-container>
	</div>
</template>

<script>
import { mapState } from 'vuex'

export default {
	name: 'relatorios-personalizados',
	computed: {
		...mapState({
			idProduto: (state) => state.loki.product.id,
		}),
	},
}
</script>
<style scoped lang="stylus">
.paineis-personalizados
	height: 100%
.az-container
	height: calc(100% - 130px)
</style>
